import { cx } from '@linaria/core';
import { pm2ConfigStore } from '@pm2/store';
import { Tooltip, SpeechButton } from '@ui/kit';
import { SpeechIcon } from '@ui/kit/icons';
import { tooltipCls, crossCls, buttonCls, audioButtonSpeechSynthesisWrapperCls, audioButtonSpeechSynthesisCls } from './atom.audio-button.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const AudioButton = props => {
  const loginDisabled = pm2ConfigStore.useSelector(state => state.config.settings.loginDisabled);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Tooltip, {
      className: tooltipCls,
      placement: "left",
      body: !props.enabled ? "Lyt til oplæsning" : "Stop oplæsning",
      ariaType: "label",
      disabled: props.enabled,
      children: ref => /*#__PURE__*/jsxs("button", {
        ref: ref,
        className: cx(buttonCls, buttonCls, props.enabled && "playbackActive"),
        onClick: props.toggleState,
        disabled: loginDisabled,
        children: [/*#__PURE__*/jsx("span", {
          className: crossCls
        }), /*#__PURE__*/jsx(SpeechIcon, {})]
      })
    }), props.speechSynthesisRootSelector && /*#__PURE__*/jsx(SpeechButton, {
      wrapperClassName: audioButtonSpeechSynthesisWrapperCls,
      className: cx(buttonCls, audioButtonSpeechSynthesisCls),
      rootSelector: props.speechSynthesisRootSelector,
      defaultTooltip: "Læs teksten op",
      hidePreSelection: true,
      withoutGuideBubble: true
    })]
  });
};

export { AudioButton };
//# sourceMappingURL=atom.audio-button.js.map
